<template>
    <v-col v-if="isMenuOpen && taskButtonsPersonal.length > 0" style="padding-top: 6px;">
        <v-row
            v-for="taskButton in taskButtonsPersonal.filter(x => x.is_visible)"
            :key="taskButton.id"
            no-gutters
        >
            <v-col
                class="shrink"
                style="white-space: nowrap"
            >
                <button
                    class="taskButton-item"
                    @click="createTask(taskButton)"
                >
                    <span class="icon-block">
                        {{ taskButton.icon }}
                    </span>
                    <span
                        style="padding: 0 12px"
                        class="body-2 truncate-text pr-6"
                    >
                        {{ taskButton.description }}
                    </span>
                </button>
            </v-col>
        </v-row>
        <v-row v-if="getLastTask()" no-gutters>
            <v-col
                class="shrink"
                style="white-space: nowrap;"
            >
                <button
                    class="taskButton-item"
                    @click="startLastTask()"
                >
                    <AccountAvatar
                        :initials="getLastTask().task_initials"
                        :color="getLastTask().task_color"
                        tile
                        size="30"
                    >
                    </AccountAvatar>
                    <span
                        style="padding: 0 12px"
                        class="body-2 truncate-text pr-6"
                    >
                        {{ getLastTask().task_title }}
                    </span>
                </button>
            </v-col>
        </v-row>
    </v-col>
</template>

<script>
import { ref, computed, watch } from "@vue/composition-api";
import { debounce } from "throttle-debounce";
import TaskModule from "@/store/modules/task";
import TimerModule from "../../store/modules/timer";
import AccountAvatar from "@/components/AccountAvatar";
import TaskButtonModule from "@/store/modules/task_button";
import errorDialog from "@/views/ErrorDialog/errorDialog";
import AccountModule from "@/store/modules/account";

export default {
    components: {
        AccountAvatar
    },
    props: {
        isMenuOpen: Boolean
    },
    setup(props) {
        const { available_company_accounts } = AccountModule();
        const {
            task_identity,
            task_color,
            task_title,
            task_id,
            task_account_id,
            status,
            task_initials,
            executeAction
        } = TimerModule();
        const { openTask } = TaskModule();
        const {
            fetchTaskButtonsPersonal,
            taskButtonsPersonal,
            createTaskButton
        } = TaskButtonModule();

        const debouncedFetchTaskButtons = debounce(10000, true, async () => {
            await fetchTaskButtonsPersonal();
        });

        watch(
            () => props.isMenuOpen,
            async () => {
                if (props.isMenuOpen === true) {
                    await debouncedFetchTaskButtons();
                }
            }
        );

        watch(task_identity, (newVal, oldVal) => {
            clearTask();
        });

        function getLastTask() {
            let taskJSON = localStorage.getItem("last_task");
            if (!taskJSON) {
                return;
            }

            let task = JSON.parse(taskJSON);

            return task;
        }

        async function startLastTask() {
            const lastTask = getLastTask()

            const company = available_company_accounts.value.find(x => x.id === lastTask.task_account_id)
            const billable = company && company.billing_settings ? company.billing_settings.time_billable : 1
            executeAction("start", getLastTask().task_id, true, null, null, billable);
        }

        function isTaskButtonTaskIdentity(value) {
            if (!value) {
                return false
            }

            return value.includes('task_button') || value.includes('taskbutton')
        }

        function clearTask() {
            if (task_id.value && !isTaskButtonTaskIdentity(task_identity.value)) {
                localStorage.setItem("last_task", null);
            }
        }

        function saveLastTask() {
            let task = {
                task_color: task_color.value,
                task_initials: task_initials.value,
                task_title: task_title.value,
                task_id: task_id.value,
                task_account_id: task_account_id.value
            };

            if (!isTaskButtonTaskIdentity(task_identity.value) && status.value === "running") {
                localStorage.setItem("last_task", JSON.stringify(task));
            }
        }

        async function createTask(taskButton) {
            saveLastTask();
            try {
                const company = available_company_accounts.value.find(x => x.id === taskButton.company_id)
                const billable = company && company.billing_settings ? company.billing_settings.time_billable : 1

                let data = await createTaskButton(taskButton.id, billable);
                openTask(data.task_id, { isTaskButtonTask: true });
            } catch (e) {
                errorDialog.showError(e)
            }
        }

        return {
            taskButtonsPersonal,
            createTask,
            startLastTask,
            getLastTask
        };
    }
};
</script>

<style lang="scss">
.taskButton-item {
    background: rgba(255, 255, 255, 0.9);
    border-radius: 99px;
    margin-bottom: 2px;
    display: flex;
    align-items: center;
    width: 100%;
    transition: all 0.2s ease-in-out;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.01), 0px 4px 8px rgba(0, 0, 0, 0.02), 0px 1px 12px rgba(0, 0, 0, 0.12);;

    &:hover {
        background: rgba(255, 255, 255, 1.0);
        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.12), 0px 6px 12px rgba(0, 0, 0, 0.12), 0px 1px 16px rgba(0, 0, 0, 0.12);;
    }
}

.icon-block {
    width: 30px;
    height: 30px;
    text-align: center;
    border-radius: 99px;
    padding-top: 8px;
    background: var(--v-white-base);
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1), 0px 4px 8px rgba(0, 0, 0, 0.08),
        0px 1px 12px rgba(0, 0, 0, 0.04);
}

.truncate-text {
    overflow: hidden;
    max-width: 150px;
    display: inline-block;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: left;
}
</style>
